import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { MenuItem } from 'primeng/api'; 
import { PanelMenuModule } from 'primeng/panelmenu';
import { Product, ProductService } from '../../../../service/product.service';
import { TableModule } from 'primeng/table';
import IDisplayModules from '../../../../domain/ports/display/i-display-modules';
import { ModuleItem } from '../../../../domain/models/moduleItem';
import { firstValueFrom } from 'rxjs';
import { LoadingService } from '../../../../service/loading.service';

@Component({
    selector: 'app-client-menu',
    standalone: true,
    imports: [CommonModule, RouterModule , TableModule],
    template: `<div class="card" style="padding-top:0px; max-height: 400px; border-radius: 0px; background: #F5F5F5; border-top: none; border-bottom: none;  border-left: none; border-right: 1px solid #D3D6D3;">
        <div style="max-height: 380px; overflow-y: auto; margin-top: 10px;">
          <p-table [value]="items" responsiveLayout="scroll" >
              <ng-template #body let-item>
                  <tr style="border-right: 2px solid black;"> 
                      <td style="width: 75%; min-width: 14rem; border: none; padding-bottom:32px; background: #F5F5F5; color: #BABBBA;  font-size:20px; font-family: 'Frutiger', 'Frutiger', sans-serif;">
                          <a routerLinkActive="active-link"
                          [routerLinkActiveOptions]="{ exact: true }" 
                          [routerLink]="['/client/cards', item.id]" 
                         [ngStyle]="{ 'font-weight': item.hasApplicationAccess ? 'bold' : 'normal' }">
                              {{ item.name }}
                          </a>
                      </td> 
                  </tr>
              </ng-template>
          </p-table>
        </div>
    </div>`,
    providers: [ProductService]
})
export class AppClientMenu {
    products!: Product[];
    userId: any;
    items: ModuleItem[] = [];
    selectedItems: any[] = [];
    statusOptions: any[] = [];
    item: any = {};
    itemDialog: boolean = false;
    submitted: boolean = false;
    totalRecords : number = 0;
    loading: boolean = false;
    editMode: boolean = false;

    constructor(@Inject('IDisplayModules') private modulesDisplayer: IDisplayModules,
        private productService: ProductService, private router: Router, private loadingService: LoadingService) {}

   async ngOnInit() {
    this.loadingService.setLoading(true);
    await this.getModules();
    if (this.items.length > 0) {
      // El loading se mantiene hasta que terminen las cards
      this.router.navigate(['/client/cards', this.items[0].id]);
    } else {
      this.loadingService.setLoading(false); 
    }
}

async getModules(): Promise<void> {
  const pageIndex = 1;
  const pageSize = 1000;
  try {
    const response = await firstValueFrom(this.modulesDisplayer.getModulesList(pageIndex, pageSize));
    if (response.status?.success) {
      this.items = response.data.data;
      this.totalRecords = response.data.totalCount;
      
    }
  } catch (error) {
    // manejar error
  }
  
}
}
